import { useState } from 'react';
import { IconDownload, IconFileInvoice } from '@tabler/icons-react';
import { Row, Col, Card } from 'antd';
import { SummaryInvoiceDataDto } from 'types';
import { AppButton, AppFlex, AppText, AppTitle } from '../../../../../../atoms';
import { settlementTexts } from '../../../../../../../consts/text';
import { useSimpleNotification } from '../../../../../../../hooks/useSimpleNotification/useSimpleNotification';
import StaffHTTPService from '../../../../../../../services/HTTPService/staff/StaffHTTPService';
import { downloadFileFromHex } from '../../../../../../../utils/fileDownload';

type AdditionalCostCorrectionInvoicesProps = {
    invoices: Array<SummaryInvoiceDataDto>;
};

export const AdditionalCostCorrectionInvoices = ({
    invoices,
}: AdditionalCostCorrectionInvoicesProps) => {
    const { displayError } = useSimpleNotification();
    const [downloadingInvoiceId, setDownloadingInvoiceId] = useState<string | null>(null);

    const handleDownloadInvoice = async (invoiceId: string, fileName: string) => {
        try {
            setDownloadingInvoiceId(invoiceId);
            const response = await StaffHTTPService.invoices.printInvoice(invoiceId);

            // The response is configured as arraybuffer, but may come as hex string
            // Convert the response data to hex string if it's not already
            const hexData =
                typeof response.data === 'string'
                    ? response.data
                    : Array.from(new Uint8Array(response.data))
                          .map((byte) => byte.toString(16).padStart(2, '0'))
                          .join('');

            downloadFileFromHex(hexData, `${fileName}.pdf`);
        } catch (error) {
            displayError(settlementTexts.children.invoices.downloadError);
            console.error('Error downloading invoice:', error);
        } finally {
            setDownloadingInvoiceId(null);
        }
    };

    if (!invoices || invoices.length === 0) {
        return null;
    }

    return (
        <div style={{ marginTop: 32 }}>
            <AppTitle level={4} style={{ marginBottom: 16 }}>
                <IconFileInvoice style={{ marginRight: 8 }} />
                Rozliczenia
            </AppTitle>
            <Row gutter={[16, 16]}>
                {invoices.map((invoice) => (
                    <Col xs={24} key={invoice.id}>
                        <Card
                            title={
                                <AppFlex align="center" gap="small">
                                    <IconFileInvoice size={16} />
                                    <AppText>Faktura korygująca</AppText>
                                </AppFlex>
                            }
                            extra={
                                <AppButton
                                    type="link"
                                    size="small"
                                    icon={<IconDownload size={16} />}
                                    loading={downloadingInvoiceId === invoice.id}
                                    onClick={() =>
                                        handleDownloadInvoice(invoice.id, invoice.invoiceNumber)
                                    }
                                >
                                    Pobierz
                                </AppButton>
                            }
                        >
                            <AppText textType="BodySmall" color="secondary">
                                {invoice.invoiceNumber}
                            </AppText>
                            <br />
                            <AppText textType="BodySmall" color="secondary">
                                Utworzono: {new Date(invoice.issueDate).toLocaleDateString('pl-PL')}
                            </AppText>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};
